import { Injectable } from '@angular/core';
import { OrganizationGroupControllerService } from '@scip/api';
import { BackendErrorService } from './backend-error.service';
import { NotificationService } from './notification.service';
import { OrganizationGroupDto } from '@scip/api';
import { catchError, map, tap } from 'rxjs/operators';
import { of, throwError, Observable } from 'rxjs';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class OrganizationGroupService {
  constructor(
    private organizationGroupControllerService: OrganizationGroupControllerService,
    private backendErrorService: BackendErrorService,
    private notificationService: NotificationService,
    private logger: NGXLogger
  ) {}

  getAllOrganizationGroups(onlyUsed: boolean = false): Observable<OrganizationGroupDto[]> {
    if (onlyUsed) {
      return this.organizationGroupControllerService.getAllUsedOganizationGroups().pipe(
        catchError((error) => {
          this.logger.error('OrganizationGroupService: Is the feature organization/le grouping enabled in the ui but not in the backend?', error);
          return of([]);
        })
      );
    } else {
      return this.organizationGroupControllerService.getAllOganizationGroups().pipe(
        catchError((error) => {
          this.logger.error('OrganizationGroupService: Is the feature organization/le grouping enabled in the ui but not in the backend?', error);
          return of([]);
        })
      );
    }
  }

  createOrganizationGroup(nameOfNewOrganizationGroup: string): Observable<OrganizationGroupDto> {
    const newOrganizationGroup: OrganizationGroupDto = {
      name: nameOfNewOrganizationGroup
    };
    return this.organizationGroupControllerService.createOrganizationGroup(newOrganizationGroup).pipe(
      catchError((error) => {
        this.backendErrorService.handleError(error, 'organizationGroupService.msg.error.creatingOrganizationGroup');
        return throwError(error);
      })
    );
  }

  deleteOrganizationGroup(identifier: string): Observable<boolean> {
    return this.organizationGroupControllerService.deleteOrganization1(identifier).pipe(
      tap(() => this.notificationService.showSuccess('profileService.msg.success.deletingOrganization')),
      map(() => true),
      catchError((error) => {
        this.backendErrorService.handleError(error);
        return of(false);
      })
    );
  }
}
